module.exports = __webpack_public_path__ + "img/sex_m.68eb05d2.svg";